import { render } from "./theAdminSidebar.vue?vue&type=template&id=5a91645d&scoped=true&ts=true"
import script from "./theAdminSidebar.vue?vue&type=script&lang=ts"
export * from "./theAdminSidebar.vue?vue&type=script&lang=ts"

import "./theAdminSidebar.vue?vue&type=style&index=0&id=5a91645d&lang=sass&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a91645d"]])

export default __exports__